var drawer = function () {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }
  var settings = {
    speedOpen: 30,
    speedClose: 350,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-drawer-target]',
    selectorTrigger: '[data-drawer-trigger]',
    selectorClose: '[data-drawer-close]',

  };


  var toggleccessibility = function (event) {
    if (event.getAttribute('aria-expanded') === 'true') {
      event.setAttribute('aria-expanded', false);
    } else {
      event.setAttribute('aria-expanded', true);
    } 
  };

 var load=function(trigger){
  fetch('/cart.js')
  .then((resp) => resp.json())
  .then((data) => {
      document.getElementById('cart__drawer_items').innerHTML="";
    if(data.items.length > 0) { 
        data.items.forEach(function(product, index) { 
            lineItem=document.getElementById('line_item').innerHTML;
            lineItem=lineItem.replaceAll("{Title}",product.title);
            lineItem=lineItem.replaceAll("{imageSrc}",product.featured_image.url);
            lineItem=lineItem.replaceAll("{imageAlt}",product.featured_image.alt);
            lineItem=lineItem.replaceAll("{Title}",product.title);
             lineItem=lineItem.replaceAll("{Price}",Number(product.line_price/100));
            lineItem=lineItem.replaceAll("{Quantity}",product.quantity);
          if(Number(product.line_price/product.quantity)!=Number(product.price)){
              lineItem=lineItem.replaceAll("{compare_at_price}","<s>$"+Number(product.price/100)+"</s>");
            }else{
              lineItem=lineItem.replaceAll("{compare_at_price}","");
            }
            lineItem=lineItem.replaceAll("{productUrl}",product.url);
            lineItem=lineItem.replaceAll("{variantId}",product.variant_id);
            lineItem=lineItem.replaceAll("{variantKey}",product.key);
             if(product.properties.preorderdate != null)
              {
 
                lineItem=lineItem.replaceAll("{preorderdate}", product.properties.preorderdate); 
              }
              else{
               lineItem=lineItem.replaceAll("{preorderdate}", "");
              }
            document.getElementById('cart__drawer_items').innerHTML += lineItem;
            $('[data-action="remove-item"]').click(function(){
             let data = {updates: {[$(this).attr('data-variant-id')]: 0}}
                fetch("/cart/update.js", {
                   method: "POST",
                   headers: {'Content-Type': 'application/json'}, 
                   body: JSON.stringify(data)
                }).then(res => {
                  GiftProcess();
                  load(trigger)
              });
            })
            $('.quantity__input').change(function(){
              let data = {updates: {[$(this).attr('data-variant-id')]: $(this).val()}}
              fetch("/cart/update.js", {
                 method: "POST",
                 headers: {'Content-Type': 'application/json'}, 
                 body: JSON.stringify(data)
              }).then(res => {
             load(trigger)
            });
            })
            });
    }
     else {
      document.getElementById('cart__drawer_items').innerHTML = '<p>Cart is empty</p>';
       
      document.getElementById('drawer_checkout_btn').setAttribute('disabled', 'disabled');
      document.getElementById('drawer_checkout_btn').style.pointerEvents = 'none';
    }
    
    document.getElementById('drawer_total_amount').innerHTML = "$"+Number(data.total_price/100);
    var target = document.getElementById(trigger.getAttribute('aria-controls'));
    target.classList.add(settings.activeClass);
    document.documentElement.style.overflow = 'hidden';
    toggleccessibility(trigger);


    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  });
 }

  var openDrawer = function (trigger) {
      load(trigger);

  };

  var closeDrawer = function (event) {
    var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.style.overflow = '';
    toggleccessibility(childrenTrigger);
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };
  var clickHandler = function (event) {
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);


    if (open) { openDrawer(open); }
    if (close) { closeDrawer(close); }
    if (open || close) { event.preventDefault(); }
  };


  var keydownHandler = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      var drawers = document.querySelectorAll(settings.selectorTarget),
        i;
      for (i = 0; i < drawers.length; ++i) {
        if (drawers[i].classList.contains(settings.activeClass)) {
          closeDrawer(drawers[i]);
        }
      }
    }
  };

  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);
};

drawer();
